import { FixMeLater } from 'types'

interface IParticipant {
  email: string
  inviteLanguage: string
  timeZone: string
}

export interface IVimeUser {
  email: string
  givenName: string
  groupIds: string[]
  isAdmin: boolean
  isHost: boolean
  username: string
  password: string
  claims: {
    [id: string]: string
  }
}

export interface IMeeting {
  id: number
  participants: IParticipant[]
  title: string
  description: null | string
  isRepeatable: boolean
  hasWaitingRoom: boolean
  isAutoRecorderEnabled: boolean
  duration: number
  hasEmailNotification: boolean
  guestMode: boolean
  isPublic: boolean
  isPasswordProtected: boolean
  deviceRestriction: number
  repeatDays: FixMeLater[]
  password: string
  publicDraw: boolean
  LinkDuration: string
  LinkCheckboxMode: boolean
  translators: FixMeLater[]
  meetingTime: string
  timeZoneOffset: number
}

export interface ConferenceClientOptions {
  enableDevices: boolean
  hideShareLink: boolean
  displayGdpr: boolean
  dontShowJoinPanel: boolean
  useCamera: boolean
  useMicrophone: boolean
  useTargetOrigin: boolean
  postMessageAsString: boolean
  locale: string
  hideChangeLanguage: boolean
  pollEnabled: boolean
  showInvitationPanel: boolean
  desktopApplicationEnabled: boolean
  showFullscreenButton: boolean
  meetingSettingsPanel: MeetingSettingsPanelConfiguration
  controlBar: ControlBarConfiguration
}

export interface ControlBarConfiguration {
  record?: boolean
  share?: boolean
  remote?: boolean
  draw?: boolean
  layout?: boolean
  hand?: boolean
  audio?: boolean
  video?: boolean
  switch?: boolean
  participants?: boolean
  chat?: boolean
  settings?: boolean
  leave?: boolean
}

export interface MeetingSettingsPanelConfiguration {
  show?: boolean
  muteAllCameras?: boolean
  muteAllMicrophones?: boolean
  togglePublicDraw?: boolean
  togglePublicMeeting?: boolean
  toggleGuestMode?: boolean
  togglePrivateChat?: boolean
  broadcastMeeting?: boolean
  pollEnabled?: boolean
}

export enum ConferenceClientMessageType {
  JoinedMeeting = 'JoinedMeeting',
  LeftMeeting = 'LeftMeeting',
  TakeScreenshot = 'TakeScreenshot',
  HasScreenshot = 'HasScreenshot',
  UnsupportedBrowser = 'UnsupportedBrowser',
  UnsupportedLanguage = 'UnsupportedLanguage',
  ChangeLanguage = 'ChangeLanguage',
  MeetingEnded = 'MeetingEnded',
  UserRoleChange = 'UserRoleChange',
}

export enum MeetingState {
  WAITING,
  STARTED,
  COMPLETED,
  CANCELLED,
  REMOVED,
}
